/* ============================================================================
   ELARIQ - pdp.js
   Product page behaviour: gallery, the tier ladder, the subscribe/one-time
   toggle, the gift rail, the stock bar and the carousels.

   The static build hardcoded the ladder as a JS array of price strings, which
   is how it ended up advertising "25% Off" on a 20% offer. Here every price,
   variant id and selling-plan id is rendered into the markup by Liquid from the
   real product, and this file only ever reads it back. A price cannot drift
   from what the customer is actually charged, because there is only one copy.
   ============================================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-pdp]');
  if (!root) return;

  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  // Document-wide lookups, for the parts of the buy box the page renders TWICE
  // (the ladder is duplicated low on the page by pdp-share, outside [data-pdp]).
  var D$$ = function (s) { return Array.prototype.slice.call(document.querySelectorAll(s)); };

  /* ---- gallery ---------------------------------------------------------- */
  (function () {
    var stage = $('[data-gallery-track]');
    if (!stage) return;
    var slides = $$('img', stage);
    var thumbs = $$('[data-gallery-thumb]');
    var at = 0;

    function go(i) {
      at = (i + slides.length) % slides.length;
      stage.style.transform = 'translateX(' + (-at * 100) + '%)';
      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === at);
        t.setAttribute('aria-current', n === at ? 'true' : 'false');
      });
    }
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });
    $$('[data-gallery-prev]').forEach(function (b) { b.addEventListener('click', function () { go(at - 1); }); });
    $$('[data-gallery-next]').forEach(function (b) { b.addEventListener('click', function () { go(at + 1); }); });

    // Swipe, because on a phone the arrows are the least likely thing to be used.
    var x0 = null;
    stage.parentElement.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    stage.parentElement.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(at + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });

    go(0);
  })();

  /* ---- tier ladder + purchase mode -------------------------------------- *
     Tiers are variants. Modes are: one-time, or the variant's selling plan.
     Everything shown is read from data- attributes Liquid wrote, so the page
     can never quote a price the cart will not honour.

     DOCUMENT-scoped, not root-scoped. `root` is the [data-pdp] wrapper, which
     only main-product.liquid emits. pdp-share renders a SECOND full buy box
     (its own ladder, price row, gift rail and add-to-cart form) outside that
     wrapper, so scoping here left that copy completely inert: its tiers had no
     click handler, its price and chip never bound (so it showed the Liquid
     fallback of the first variant's price next to a visibly selected tier that
     costs twice as much, and an empty chip pill), and its form's hidden id
     field was never written, so it added the FIRST variant to the cart whatever
     the shopper had selected. The ladder is already keyed by data-step rather
     than by document position precisely so two copies can share one state.   */
  (function () {
    var tiers = D$$('[data-tier]');
    if (!tiers.length) return;

    // Every add-to-cart form on the page, not just the first one.
    var forms = D$$('[data-atc-form]');
    var modes = D$$('[data-mode]');
    var subscribeAvailable = tiers.some(function (t) { return t.dataset.sellingPlan; });

    // Identify a tier by its STEP, not by its position in the document. The
    // page carries the ladder twice, once in the buy box and once in the stock
    // up section, and indexing by position made the second copy renumber the
    // first: clicking a tier in one selected a different variant in the other.
    var at = 1;
    var firstDefault = tiers.filter(function (t) { return t.dataset.default === 'true'; })[0];
    if (firstDefault) at = Number(firstDefault.dataset.step);
    // Subscribe is the default per the offer, but only if a plan actually exists.
    var mode = (subscribeAvailable && root.dataset.defaultMode !== 'one') ? 'sub' : 'one';

    function bind(name, value) {
      D$$('[data-bind="' + name + '"]').forEach(function (el) { el.textContent = value; });
    }

    var byStep = function (step) {
      return tiers.filter(function (x) { return Number(x.dataset.step) === step; })[0];
    };

    function render() {
      var t = byStep(at) || tiers[0];
      var sub = mode === 'sub' && t.dataset.sellingPlan;

      tiers.forEach(function (el) {
        var isOn = Number(el.dataset.step) === at;
        el.classList.toggle('sel', isOn);
        el.setAttribute('aria-checked', isOn ? 'true' : 'false');
        // Each card shows the price for the mode in play, with the other struck.
        var now = el.querySelector('[data-tier-price]');
        var was = el.querySelector('[data-tier-was]');
        var showSub = mode === 'sub' && el.dataset.sellingPlan;
        if (now) now.textContent = showSub ? el.dataset.subPrice : el.dataset.price;
        if (was) was.textContent = showSub ? el.dataset.price : (el.dataset.comparePrice || '');
        if (was) was.hidden = !was.textContent;
      });

      modes.forEach(function (m) {
        m.classList.toggle('sel', m.dataset.mode === mode);
        m.setAttribute('aria-pressed', m.dataset.mode === mode ? 'true' : 'false');
      });

      // Both mode buttons show their own price for the selected tier, so the
      // comparison is visible without toggling. A tier with no selling plan
      // falls back to its one-time price rather than rendering empty.
      bind('msub', t.dataset.subPrice || t.dataset.price);
      bind('mone', t.dataset.price);

      bind('price', sub ? t.dataset.subPrice : t.dataset.price);
      bind('was', sub ? t.dataset.price : (t.dataset.comparePrice || ''));
      bind('chip', t.dataset.chip || '');
      bind('atclabel', sub ? (root.dataset.labelSubscribe || 'Subscribe and Save')
                           : (root.dataset.labelOnce || 'Add to cart'));
      D$$('[data-atc-sub]').forEach(function (el) {
        el.hidden = !sub;
      });
      D$$('[data-atc-once]').forEach(function (el) {
        el.hidden = !!sub;
      });

      // The gift rail marks what the SELECTED tier unlocks and what is still
      // locked, so the ladder reads as a reason to move up rather than as a
      // list of things you do not have.
      // The unlock threshold is the gift's OWN step, not its position in the
      // rail: the two ladders do not line up on this offer (Buy 1 unlocks
      // nothing, Buy 3 Get 2 Free unlocks the last two together).
      var unlockedGifts = [];
      D$$('[data-gift]').forEach(function (g) {
        var needs = Number(g.dataset.giftStep) || Number(g.dataset.gift);
        var unlocked = needs <= at;
        g.classList.toggle('is-locked', !unlocked);
        var lock = g.querySelector('[data-gift-lock]');
        if (lock) lock.hidden = unlocked;
        if (unlocked) {
          var name = g.querySelector('.gn');
          name = name && name.textContent.trim();
          // The rail is rendered twice, so the same gift arrives twice.
          if (name && unlockedGifts.indexOf(name) < 0) unlockedGifts.push(name);
        }
      });

      // Carry the unlocked gifts into the cart as a line item property. Whatever
      // the rail is showing as unlocked is exactly what the order records, so
      // the two can never disagree, and a tier that unlocks nothing writes an
      // empty value that theme.js drops rather than a blank cart row.
      D$$('[data-gift-props]').forEach(function (el) { el.value = unlockedGifts.join(' + '); });

      // Both forms, or the second buy box posts the first variant whatever the
      // shopper picked.
      forms.forEach(function (f) {
        var idField = f.querySelector('[name="id"]');
        var planField = f.querySelector('[name="selling_plan"]');
        if (idField) idField.value = t.dataset.variant;
        if (planField) {
          planField.value = sub ? t.dataset.sellingPlan : '';
          planField.disabled = !sub;
        }
      });
    }

    tiers.forEach(function (el) {
      var step = Number(el.dataset.step);
      el.addEventListener('click', function () { at = step; render(); });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); at = step; render(); }
      });
    });
    modes.forEach(function (m) {
      m.addEventListener('click', function () { mode = m.dataset.mode; render(); });
    });

    render();
  })();

  /* ---- delivery estimate ------------------------------------------------ */
  (function () {
    var el = $('[data-ship-eta]');
    if (!el) return;
    var days = parseInt(el.dataset.shipEta, 10) || 3;
    var d = new Date();
    d.setDate(d.getDate() + days);
    el.textContent = d.toLocaleDateString(document.documentElement.lang || 'en-US',
      { weekday: 'short', month: 'short', day: 'numeric' });
  })();

  /* ---- stock bar -------------------------------------------------------- */
  (function () {
    var bars = $$('[data-stockbar]');
    if (!bars.length || !('IntersectionObserver' in window)) {
      bars.forEach(function (b) { b.style.width = b.dataset.stockbar + '%'; });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.style.width = e.target.dataset.stockbar + '%';
        io.unobserve(e.target);
      });
    }, { threshold: 0.4 });
    bars.forEach(function (b) { io.observe(b); });
  })();

  /* ---- sticky ATC on the product page ----------------------------------- */
  (function () {
    var bar = document.querySelector('[data-stickybuy]');
    var box = $('[data-buybox]');
    if (!bar || !box || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.hidden = entries[0].isIntersecting;
    }, { rootMargin: '0px 0px -80% 0px' }).observe(box);
  })();
})();
